module.exports = __webpack_public_path__ + "static/media/farePremierBenefits.pictogram.7f8cbfbd.svg";